<div>
  <!-- Left Sidebar -->
  <aside id="leftsidebar" class="sidebar" (mouseenter)="mouseHover($event)" (mouseleave)="mouseOut($event)">
    <!-- Menu -->
    <div class="menu">
      <ul
        class="list"
        [ngStyle]="{
          position: 'relative',
          'max-height': listMaxHeight + 'px',
          'max-width': listMaxWidth + 'px'
        }"
        [perfectScrollbar]
      >
        <!-- User info -->
        <li class="sidebar-user-panel">
          <div class="user-panel">
            <div class="image">
              <img [src]="'assets/images/user/profile_img.png'" class="img-circle" alt="" />
            </div>
          </div>
          <div class="profile-usertitle">
            <div class="sidebar-userpic-name">{{ userName }}</div>
            <div class="profile-usertitle-job">{{ userRole }}</div>
          </div>
        </li>

        <!-- Top-level menu -->
        <li
          [class.active]="level1Menu === sidebarItem.moduleName && sidebarItem.submenu.length != 0"
          *ngFor="let sidebarItem of sidebarItems"
          [routerLinkActive]="sidebarItem.submenu.length != 0 ? '' : 'active'"
        >
          <div class="header" *ngIf="sidebarItem.groupTitle === true">
            {{ sidebarItem.title | translate }}
          </div>

          <!-- Corrected: <a> tag is closed BEFORE submenu -->
          <a
            *ngIf="!sidebarItem.groupTitle"
            [routerLink]="sidebarItem.submenu.length === 0 ? [sidebarItem.path] : null"
            [ngClass]="[sidebarItem.class]"
            (click)="sidebarItem.submenu.length > 0 && callLevel1Toggle($event, sidebarItem.moduleName)"
            class="menu-top"
          >
            <i-feather [name]="sidebarItem.icon" class="sidebarIcon"></i-feather>
            <span class="hide-menu">{{ sidebarItem.title | translate }}</span>
            <span *ngIf="sidebarItem.badge != ''" [ngClass]="[sidebarItem.badgeClass]">
              {{ sidebarItem.badge }}
            </span>
          </a>

          <!-- First-level submenu -->
          <ul class="ml-menu" *ngIf="sidebarItem.submenu.length > 0">
            <li
              [ngClass]="level2Menu === sidebarSubItem.moduleName ? 'activeSub' : ''"
              *ngFor="let sidebarSubItem of sidebarItem.submenu"
              [routerLinkActive]="sidebarSubItem.submenu.length > 0 ? '' : 'active'"
            >
              <a
                [routerLink]="sidebarSubItem.submenu.length > 0 ? null : [sidebarSubItem.path]"
                (click)="callLevel2Toggle($event, sidebarSubItem.moduleName)"
                [ngClass]="[sidebarSubItem.class]"
              >
                {{ sidebarSubItem.title | translate }}
              </a>

              <!-- Second-level submenu -->
              <ul class="ml-menu-2" *ngIf="sidebarSubItem.submenu.length > 0">
                <li
                  *ngFor="let sidebarSubsubItem of sidebarSubItem.submenu"
                  [ngClass]="level3Menu === sidebarSubsubItem.moduleName ? 'activeSubSub' : ''"
                  [routerLinkActive]="sidebarSubsubItem.submenu.length > 0 ? '' : 'active'"
                >
                  <a
                    [routerLink]="sidebarSubsubItem.submenu.length > 0 ? null : [sidebarSubsubItem.path]"
                    (click)="callLevel3Toggle($event, sidebarSubsubItem.moduleName)"
                    [ngClass]="[sidebarSubsubItem.class]"
                  >
                    {{ sidebarSubsubItem.title | translate }}
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </li>

        <!-- Logout -->
        <li>
          <a (click)="logout()" class="menu-top">
            <i-feather name="log-out" class="sidebarIcon"></i-feather>
            <span class="hide-menu">Logout</span>
          </a>
        </li>
      </ul>
    </div>
    <!-- #Menu -->
  </aside>
  <!-- #END# Left Sidebar -->
</div>
